import http from '../../../Services/api.laravel.http';

export const PurchaseOrderTemplateSettingService = {
 	getPOTemplateSettings: () => http.get('/admin/po-template/settings/po-template'),
 	storePOTS: (formParams) => http.post('/admin/po-template/settings/po-template', formParams),
	setAsDefault: (formParams) => http.post('/admin/po-template/settings/default', formParams),
	poTemplateSettingArchive: (formParams) => http.post('/admin/po-template/settings/archive', formParams),
	getSinglePOTS: (id) => http.get(`/admin/po-template/settings/${id}`),
	updatePOTS: (formParams) => http.post('/admin/po-template/settings/update', formParams)
}